// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width:767px){.feature-section{--tw-aspect-h:3!important;--tw-aspect-w:2!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
